import type { TabsDefinition } from '@/src/experiences/tabs'
import { HomeOutlined } from '@/src/assets/icons/HomeOutlined'

export const HomeTab = {
  home: {
    name: 'home',
    title: 'Home',
    Icon: HomeOutlined,
    href: `/main/(tabs)/home`,
    options: {},
  },
} as const satisfies TabsDefinition
